import CryptoJS from 'crypto-js/crypto-js';
import 'jsencrypt/bin/jsencrypt';
const keyMapping = {}, requestIsEncrypt = false;
// process.env.NODE_ENV === 'production';

const Base = {
    /**
     * 3DES加密
     * @param {*} password
     * @param {*} data
     */
    tripleDESEncrypt(password, data) {
        let encrypted = CryptoJS.TripleDES.encrypt(data, CryptoJS.enc.Utf8.parse(password), {
            iv: CryptoJS.enc.Utf8.parse('01234567'),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },


    /**
     * 3DES解密
     * @param {*} password
     * @param {*} data
     */
    tripleDESDecrypt(password, data) {
        let encrypted = CryptoJS.TripleDES.decrypt(data, CryptoJS.enc.Utf8.parse(password), {
            iv: CryptoJS.enc.Utf8.parse('01234567'),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return CryptoJS.enc.Utf8.stringify(encrypted);
    },

    /**
     * RSA公钥加密
     * @param {*} publicKey
     * @param {*} data
     */
    rsaEncrypt(publicKey, data) {
        let jse = new JSEncrypt();
        jse.setPublicKey(publicKey);
        return jse.encrypt(data)
    },

    /**
     * 获取随机数
     * @param {*} length
     */
    getRandom(length) {
        return CryptoJS.lib.WordArray.random(length).toString();
    }
}

export default function initEncrypt(context) {
    context.$configure.set('httpSuccessHandler', function (response, cb) {
        let isJsonResponse = response.config.responseType === 'json',
            isStreamResponse = response.headers['content-type'] === 'application/octet-stream',
            responseIsSuccess = response.data.code === 200 || response.data.errcode === 0 || (isJsonResponse && response.data) || isStreamResponse || response.config.responseType === 'blob';
        if(response.data.code == 601){
            try {
                context.$vue.prototype.$token.commit('CLEAR_USER');
                context.$vue.prototype.$token.commit('CLEAR_MENU');
                context.$vue.prototype.$token.commit('CLEAR_PERMISSION_BUTTONS');
                sessionStorage.removeItem("schoolId");
                sessionStorage.removeItem("semester");
                sessionStorage.removeItem("schoolYear");
                sessionStorage.removeItem("schoolTime1");
                sessionStorage.removeItem("schoolTime2");
            } catch (e) {}
            try{
                context.$vue.prototype.$token.clean();
            }catch(e){}
            //http://localhost:8081/index
            //https://lvliang-admin-test.51xuekexue.com/school
            let href = window.location.origin;
            let ServerHost;
            if(href.includes('192.168') || href.includes('localhost')){
                ServerHost = "http://192.168.1.8:8081/login"
            }else if(href.includes('test.')){
                ServerHost = "https://lvliang-index-test.51xuekexue.com/login"
            }else{
                ServerHost = "https://lvliang-index.51xuekexue.com/login"
            }
            window.location.replace(ServerHost)
        }
        if(requestIsEncrypt && responseIsSuccess && !isStreamResponse){
            let encryptKey = response.config.headers['a-k-l-t'],
                key = keyMapping[encryptKey];

            delete keyMapping[encryptKey];

            if(key){
                let responseData;

                if(response.data.data){
                    let decryptResponse = Base.tripleDESDecrypt(key, response.data.data);

                    try {
                        decryptResponse = JSON.parse(decryptResponse);
                    } catch (e) {}

                    responseData = Object.assign({}, response.data, {
                        data: decryptResponse
                    })
                }else{
                    responseData = Base.tripleDESDecrypt(key, response.data);
                }

                response.data = responseData;
            }
        }

        cb(responseIsSuccess);
    });

    context.$configure.set('requestBeforeSend',function (config) {
        let data = config.data, random;

        if(requestIsEncrypt && !(config.baseURL || '').includes('/encrypt/ignore/')){
            // 生产随机密码
            random = Base.getRandom(8);

            let encryptKey = Base.rsaEncrypt('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjjAmfrnMBzyHTNdP/Uo3\n' +
                'brcUZzD14+jzQdXpfNiShk2xg0A86stviyZYHwQDZGZ7ND/7pL5uGYbam2WQk6Fj\n' +
                'Hm5Em5S1I6AopdTEhbFFCgbUqsmBY6BH33hJX1roZKZ0OUoVT+OZcA1W7O5KlWST\n' +
                'gKqwyJKyiz8EXrPKKbQxFwixDNmUzf/qmafE+ee3zjD3d4tqzqHon7SDydcizU5F\n' +
                'UJzmZWYnkRdYC79wWyjW1jSXlWoTwnKGaojjTJFH/NkR3NRbNXColeA75kmJ64Ey\n' +
                'p0clRiv2TJYRa7VtnOu5idac7fuPlw75Y8+11OxlYPyY660x9utn9dRl3RhL1iqB\n' +
                'mwIDAQAB', random);

            // 密码RSA加密
            config.headers['a-k-l-t'] = encryptKey;

            keyMapping[encryptKey] = random;
        }

        if(data){
            if(![undefined, null, ''].includes(data.pageSize) && !config.url.includes('pageNum')){
                let pageParamStr = ['pageNum', 'pageSize'].map(name => `${name}=${data[name]}`).join('&');

                config.url = config.url.includes('?') ? config.url + pageParamStr : config.url + '?' + pageParamStr;
            }

            if(requestIsEncrypt && !(config.baseURL || '').includes('/encrypt/ignore/')){
                // 数据加密
                config.data = Base.tripleDESEncrypt(random, JSON.stringify(data));
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/configure/encrypt.js